import React from 'react'
import FetchData from '../../../shared/fetchData'
import { checkValidity, updateObject } from '../../../shared/utility'
import Button from '../../UI/Button/Button'
import Input from '../../UI/Input/Input'
import Table from '../../UI/Table/Table'
import './Transactions.css'

const Transactions = (props) => {
    const [loading, setLoading] = React.useState(false)
    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [transactions, setTransactions] = React.useState([])
    const [searchParam, setSearchParam] = React.useState({
        comment: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'توضیحات'
            },
            valid: true,
            value: ''
        }
    })
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParam, {
            [controlName]: updateObject(searchParam[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, searchParam[controlName].validation)
            })
        });
        setSearchParam(updatedControls)
    }

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
    }, [])

    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "creditChange": {
                "unitId": props.unitId,
                "comment": searchParam.comment.value
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnitTransactions'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.transactions)
                    pushData(newList)
                    setTransactions(newList)
                    setPageCount(result.count)
                    setLoading(false);
                }
            })
            .catch(error => console.log(error))
    }
    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'changeType',
                header: "نوع تغییرات",
                align: 'center',
            },
            {
                accessorKey: 'description',
                header: 'علت افزایش/ کاهش',
                align: 'center',
            },
            {
                accessorKey: 'balance',
                header: "مبلغ",
                align: 'center',
            },
            {
                accessorKey: 'comment',
                header: "توضیحات",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                changeType: d.changeType,
                description: d.description,
                balance: d.value != null && d.value != '' ? d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0',
                comment: d.comment,
            });
        })
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }

    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    const formElementsArray = [];
    for (let key in searchParam) {
        formElementsArray.push({
            id: key,
            config: searchParam[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col="4 p-0 mt-3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });
    return (
        <>
            <div className="row justify-content-center mt-1">
                {form}
                <div className='col-4 mt-4'>
                    <Button btnType="Success" clicked={search} >جستجو</Button>
                </div>
            </div>

            {rerender ?
                // <Spinner />
                <Table hasDetails={false} pageSize={pageSize} data={transactions} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={200} loading={loading} />
                :
                <Table hasDetails={false} pageSize={pageSize} data={transactions} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={200} loading={loading} />
            }
            <div className="row justify-content-center mt-1">
                <Button btnType="Success" clicked={props.back} >برگشت</Button>
            </div>
        </>
    )
}

export default Transactions